import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CFormLabel,
  CLoadingButton,
  CModalHeader,
  CModalTitle,
  CForm,
  CRow,
  CFormInput,
  CFormFeedback,
} from '@coreui/react-pro'
import React, { useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import ToastComponent from 'src/components/common/TaostComponent'
import { useNavigate } from 'react-router-dom'
import GradeService from 'src/service/GradeService'

const MultiplierModal = (props) => {
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false)
  const validationSchema = Yup.object().shape({
    point: Yup.string().required('Multiplier is required'),
  })
  const formik = useFormik({
    initialValues: {
      point: '',
    },
    validationSchema,
    onSubmit: (data, actions) => {
      data.gradeId = props.gradeId
      actions.resetForm({
        values: {
          point: '',
        },
      })
      setLoader(true)
      GradeService.mulitplyGrade(data)
        .then((res) => {
          if (res.status === 200) {
            props.setVisible(false)
            props.toggleDetails(props.gradeId)
            ToastComponent(res.message, 'success')
            setLoader(false)
          } else {
            setLoader(false)
            ToastComponent(res.message, 'error')
          }
        })
        .catch((e) => {
          ToastComponent(e.response?.data?.message, 'error')
          setLoader(false)
          ToastComponent(e.response?.data?.message, 'error')
        })
    },
  })

  return (
    <>
      <CModal visible={props.visible} onClose={() => props.setVisible(false)}>
        <CForm className="" onSubmit={formik.handleSubmit}>
          <CModalHeader>
            <CModalTitle>Set Your Multiplier</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p className="text-medium-emphasis small mb-3">
              Every saved point value in this comp&apos;s point system (all items, for Bowler,
              Batsman, Wicket Keeper and All Rounder) will be multiplied by the number you enter.
              Negative points scale too. Save any unsaved changes first, as the multiplier works on
              the saved values.
            </p>
            <CRow className="">
              <CFormLabel htmlFor="point" className="col-sm-4 col-form-label">
                {'Multiply By'}
              </CFormLabel>
              <div className="col-sm-8 mb-3 pt-2">
                <CFormInput
                  type="number"
                  id="point"
                  className={
                    'form-control' +
                    (formik.errors.point && formik.touched.point ? ' is-invalid' : '')
                  }
                  value={formik.values.point}
                  name="point"
                  onChange={formik.handleChange}
                  step="0.01"
                  placeholder="e.g. 2"
                />
                {formik.errors.point && formik.touched.point && (
                  <CFormFeedback invalid>{formik.errors.point}</CFormFeedback>
                )}
                <div className="form-text">
                  {formik.values.point !== ''
                    ? `e.g. 1 Wicket worth 20 becomes ${+(20 * formik.values.point).toFixed(2)}`
                    : 'e.g. 2 doubles every value, 0.5 halves it'}
                </div>
              </div>
            </CRow>
          </CModalBody>
          <CModalFooter>
            <CLoadingButton type="submit" color="success" variant="outline" loading={loader}>
              Apply
            </CLoadingButton>
            <CButton color="danger" onClick={() => props.setVisible(false)}>
              Close
            </CButton>
          </CModalFooter>
        </CForm>
      </CModal>
    </>
  )
}

export default MultiplierModal
